"use client";
import T from "@marginly/ui/components/typography";
import React from "react";
import { useAccount } from "wagmi";

import Space from "@/components/common/space";
import { CONTEST_ID } from "@/components/raffle/constants";
import { useGetContestRaffles, useGetScore } from "@/components/raffle/hooks";
import { useMemberInfo } from "@/contexts/contest-member-info/hooks";
import { getPlural } from "@/util/get-plural";

import { RegistrationButton } from "../registration-button";
import { TimerLabel } from "../timer-label";
import * as S from "./styled";

export function TitleSection() {
  const { refCode } = useMemberInfo();
  const raffles = useGetContestRaffles(CONTEST_ID);
  const nextRaffle = raffles.find((raffle) => !raffle.winnersSelectedAt);
  const raffleDate = nextRaffle ? new Date(nextRaffle.raffleDate) : new Date();
  const { address } = useAccount();
  const score = useGetScore(CONTEST_ID, address);
  const sumScore = score?.reduce((sum, item) => sum + item.score, 0) ?? 0;

  return (
    <S.Wrapper>
      <S.Inner>
        <div>
          <T title>
            {sumScore ? (
              <>
                You have
                <br />
                {getPlural(sumScore, "ticket")}
              </>
            ) : refCode ? (
              <>
                You are
                <br />
                registered
              </>
            ) : (
              <>Achievement system</>
            )}
          </T>
          <Space height={12} heightMobile={12} />
          <T secondary>
            {sumScore
              ? "Your tickets will be drawn in the next raffle."
              : refCode
              ? "Start completing tasks to get lottery tickets."
              : "$10K in prizes up for grabs."}
          </T>
          <Space height={32} heightMobile={32} />
          {raffleDate > new Date() && (
            <>
              <TimerLabel endTime={raffleDate} textBefore="Next raffle in " />
              <Space height={48} heightMobile={48} />
            </>
          )}
          <RegistrationButton />
        </div>
      </S.Inner>
    </S.Wrapper>
  );
}
